import React from 'react';
import { SectionWrapper } from '../ui/SectionWrapper';
import { BrainIcon, LinkIcon, RotateCcwIcon, ScanEyeIcon, UnlockIcon } from 'lucide-react';
export function MechanismSection() {
  return <SectionWrapper id="metodo" withGlow data-id="element-133">
      <div className="max-w-4xl mx-auto" data-id="element-134">
        <div className="text-center mb-16" data-id="element-135">
          <p className="text-[#c9a84c] text-sm font-semibold tracking-[0.2em] uppercase mb-6" data-id="element-136">
            La ciencia detrás del cambio real
          </p>
          <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-bold text-[#e8e6e1] mb-6 leading-tight" data-id="element-137">
            Por qué la motivación{' '}
            <span className="text-gold-gradient" data-id="element-138">nunca funcionó</span>
          </h2>
          <p className="text-lg md:text-xl text-[#9a9aab] max-w-2xl mx-auto leading-relaxed" data-id="element-139">
            La motivación opera en la superficie. Tu problema está en la raíz:
            <span className="text-[#e8e6e1] font-medium" data-id="element-140">
              {' '}
              tu identidad subconsciente.
            </span>
          </p>
        </div>

        {/* Explanation block */}
        <div className="bg-[#0d1321]/80 border border-[#252b45] rounded-2xl p-8 md:p-12 mb-16" data-id="element-141">
          <p className="text-[#9a9aab] text-lg leading-relaxed mb-6" data-id="element-142">
            Tu cerebro opera con un{' '}
            <span className="text-[#e8e6e1] font-medium" data-id="element-143">
              sistema de identidad
            </span>{' '}
            que fue programado por tus experiencias, creencias heredadas y
            patrones repetidos durante años. Cada vez que intentas cambiar con
            fuerza de voluntad, tu subconsciente te regresa al "programa
            original" porque{' '}
            <span className="text-[#c9a84c]" data-id="element-144">
              eso es lo que reconoce como "tú".
            </span>
          </p>
          <p className="text-[#9a9aab] text-lg leading-relaxed" data-id="element-145">
            No necesitas más motivación. Necesitas{' '}
            <span className="text-[#e8e6e1] font-semibold" data-id="element-146">
              reprogramar el código fuente de tu identidad.
            </span>{' '}
            Eso es exactamente lo que hace el Método N.E.X.U.S.™
          </p>
        </div>

        {/* Method N.E.X.U.S. */}
        <div className="text-center mb-12" data-id="element-147">
          <h3 className="font-display text-2xl md:text-3xl font-bold gold-shimmer mb-2" data-id="element-148">
            Método N.E.X.U.S.™
          </h3>
          <p className="text-[#6b6b7b] text-sm tracking-wider uppercase" data-id="element-149">
            Neuro-Espiritual de Transformación Unificada del Ser
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-5 gap-6" data-id="element-150">
          <div className="flex flex-col items-center text-center p-6 rounded-xl bg-[#0d1321]/60 border border-[#252b45]/50" data-id="element-151">
            <div className="w-12 h-12 rounded-full bg-[#c9a84c]/10 flex items-center justify-center mb-4" data-id="element-152">
              <ScanEyeIcon className="w-6 h-6 text-[#c9a84c]" aria-hidden="true" data-id="element-153" />
            </div>
            <span className="text-[#c9a84c] font-bold text-lg mb-1" data-id="element-154">N</span>
            <span className="text-[#e8e6e1] text-sm font-medium mb-2" data-id="element-155">
              Neuroplasticidad
            </span>
            <p className="text-[#6b6b7b] text-xs leading-relaxed" data-id="element-156">
              Reconecta tus patrones neuronales
            </p>
          </div>

          <div className="flex flex-col items-center text-center p-6 rounded-xl bg-[#0d1321]/60 border border-[#252b45]/50" data-id="element-157">
            <div className="w-12 h-12 rounded-full bg-[#c9a84c]/10 flex items-center justify-center mb-4" data-id="element-158">
              <BrainIcon className="w-6 h-6 text-[#c9a84c]" aria-hidden="true" data-id="element-159" />
            </div>
            <span className="text-[#c9a84c] font-bold text-lg mb-1" data-id="element-160">E</span>
            <span className="text-[#e8e6e1] text-sm font-medium mb-2" data-id="element-161">
              Eliminación
            </span>
            <p className="text-[#6b6b7b] text-xs leading-relaxed" data-id="element-162">
              Borra creencias limitantes
            </p>
          </div>

          <div className="flex flex-col items-center text-center p-6 rounded-xl bg-[#0d1321]/60 border border-[#252b45]/50" data-id="element-163">
            <div className="w-12 h-12 rounded-full bg-[#c9a84c]/10 flex items-center justify-center mb-4" data-id="element-164">
              <LinkIcon className="w-6 h-6 text-[#c9a84c]" aria-hidden="true" data-id="element-165" />
            </div>
            <span className="text-[#c9a84c] font-bold text-lg mb-1" data-id="element-166">X</span>
            <span className="text-[#e8e6e1] text-sm font-medium mb-2" data-id="element-167">
              Conexión
            </span>
            <p className="text-[#6b6b7b] text-xs leading-relaxed" data-id="element-168">
              Alinea mente y espíritu
            </p>
          </div>

          <div className="flex flex-col items-center text-center p-6 rounded-xl bg-[#0d1321]/60 border border-[#252b45]/50" data-id="element-169">
            <div className="w-12 h-12 rounded-full bg-[#c9a84c]/10 flex items-center justify-center mb-4" data-id="element-170">
              <UnlockIcon className="w-6 h-6 text-[#c9a84c]" aria-hidden="true" data-id="element-171" />
            </div>
            <span className="text-[#c9a84c] font-bold text-lg mb-1" data-id="element-172">U</span>
            <span className="text-[#e8e6e1] text-sm font-medium mb-2" data-id="element-173">
              Unificación
            </span>
            <p className="text-[#6b6b7b] text-xs leading-relaxed" data-id="element-174">
              Integra tu nueva identidad
            </p>
          </div>

          <div className="flex flex-col items-center text-center p-6 rounded-xl bg-[#0d1321]/60 border border-[#252b45]/50" data-id="element-175">
            <div className="w-12 h-12 rounded-full bg-[#c9a84c]/10 flex items-center justify-center mb-4" data-id="element-176">
              <RotateCcwIcon className="w-6 h-6 text-[#c9a84c]" aria-hidden="true" data-id="element-177" />
            </div>
            <span className="text-[#c9a84c] font-bold text-lg mb-1" data-id="element-178">S</span>
            <span className="text-[#e8e6e1] text-sm font-medium mb-2" data-id="element-179">
              Sostenimiento
            </span>
            <p className="text-[#6b6b7b] text-xs leading-relaxed" data-id="element-180">
              Mantén el cambio permanente
            </p>
          </div>
        </div>
      </div>
    </SectionWrapper>;
}